export default function VideoGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
        >
          <div className="aspect-video w-full animate-pulse bg-background-200" />
          <div className="space-y-3 p-4">
            <div className="h-4 w-4/5 animate-pulse rounded bg-background-200" />
            <div className="h-4 w-3/5 animate-pulse rounded bg-background-200" />
            <div className="h-3 w-2/5 animate-pulse rounded bg-background-200" />
          </div>
        </div>
      ))}
    </div>
  );
}